import WelligenceLogoTransparent from '@assets/images/welligence-transparent.png';
import { Box } from '@mui/material';

export const WatermarkLogo = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: '2px',
        right: '40px',
        zIndex: 999999,
        pointerEvents: 'none',
      }}
    >
      <img src={WelligenceLogoTransparent} alt="Welligence Logo" style={{ width: '100px' }} />
    </Box>
  );
};
